import { AppConstant } from "../constant/AppConstant";
import { getLocalStorage, setLocalStorage } from "./localStorageHelper";
import { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction;

export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const getNavigate = () => navigate;

export function showLog(message?: any, ...optionalParams: any[]): void {
  console.log(message, ...optionalParams);
}

export const getDateFormate = (
  dateString: string
) => {
  const date = new Date(dateString);
  const formatedString = !isNaN(date.getTime())
    ? date.toLocaleDateString("en-GB")
    : "Invalid Date";
  return formatedString;
};

export const filterSince1970 = (date: Date) => {
  const minDate = new Date(1970, 0, 1);
  return date >= minDate;
};

export const disableWeekends = (date: Date) => {
  const day = date.getDay();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (day >= 1 && day <= 5) && date >= today;
};

export const getTimeFormate = (dateString: string) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Time";

  const browserTimeZone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  return date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: browserTimeZone,
  });
};

export const getAdminId = () => {
  return getLocalStorage(AppConstant.adminId) as string;
};

export const getCreatedById = () => {
  return getLocalStorage(AppConstant.createdById) as string;
};

export const getIsPartner = () => {
  return getLocalStorage(AppConstant.isPartner) === "true" ? true : false;
};

export const setIsPartner = (isPartner: boolean) => {
  setLocalStorage(AppConstant.isPartner, isPartner);
};

export const setPartnerId = (partnerId: string) => {
  setLocalStorage(AppConstant.partnerId, partnerId);
};

export const getPartnerId = () => {
  return getLocalStorage(AppConstant.partnerId) as string;
};

export const getLast12Months = (): string[] => {
  const monthsList: string[] = [];
  const currentDate = new Date();

  for (let i = 11; i >= 0; i--) {
    const date = new Date(currentDate);
    date.setMonth(date.getMonth() - i);
    const yearMonth = `${date.getFullYear()}-${date.getMonth() + 1}`;
    monthsList.push(yearMonth);
  }

  return monthsList;
};

export const formatDateOnly = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const openInNewTab = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};